import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-supplier-select-item',
  templateUrl: './supplier-item.component.html',
  styles: [],
  standalone: false
})
export class SupplierSelectItemComponent {
  @Input() supplier: any = {};

  color: { [key: number]: string } = {
    0: '#87d068',
    1: '#f25f12',
    2: '#f50'
  };
  status: { [key: number]: string } = {
    0: 'ACTIVE',
    1: 'INACTIVE',
    2: 'SUSPENDED'
  };
  constructor() {}
}
